module.exports = __webpack_public_path__ + "static/media/get-refund-icon.8b69135a.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/TCH-WEB/get-refund-icon.svg
// module id = 1293
// module chunks = 0